import { type MetricType } from "../metric";

type Add = "+";
type Subtract = "-";
type Multiply = "*";
type Divide = "/";

export type Operator = Add | Subtract | Multiply | Divide;

const NUMBER = "number" as const;
const OPERATOR = "operator" as const;
const VARIABLE = "variable" as const;

export type NumberNode = {
  type: typeof NUMBER;
  value: string;
};

export type VariableNode = {
  type: typeof VARIABLE;
  value: string;
};

export type OperatorNode = {
  type: typeof OPERATOR;
  value: Operator;
  left: AstNode;
  right: AstNode;
};

export type AstNode = NumberNode | OperatorNode | VariableNode;

export enum NODE_TYPE {
  NUMBER = "number",
  OPERATOR = "operator",
  VARIABLE = "variable",
}

export type Token = {
  type: NODE_TYPE;
  value: string;
  id: string;
};

export type CustomMetric = {
  id?: number;

  name: string;
  description: string;
  data_type: MetricType;
  accounting_mode: string;
  formula: AstNode | null;
  is_negative_trend_good: boolean;
  isTemplate: boolean | null;
};
